<div class="check-deposit-container">
  @if (!isLoading() && customerToken && unitAccountId) {
    @if (!stylesLoaded()) {
      <div class="loader-container">
        <terra-loader />
      </div>
    }
    <div [ngClass]="{'block-hidden': !stylesLoaded()}">
      <unit-elements-check-deposit 
        #checkDeposit
        [attr.account-id]="unitAccountId" 
        fee="0" 
        [attr.customer-token]="customerToken" 
        theme="" 
        initial-stage-back-button="false" 
        final-stage-done-button="false" 
        enable-device-handoff="true"
        (unitOnLoad)="unitOnLoad($event)">
        >
      </unit-elements-check-deposit>
    </div>
  } @else {
    <div class="loader-container">
      <terra-loader />
    </div>
  }
</div>